import React from 'react';

function TruckCheckModal({ onClose, onCheckIn, onCheckOut }) {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: window.innerWidth <= 768 ? '20px' : '0'
    }}>
      <div style={{
        background: 'white',
        borderRadius: window.innerWidth <= 768 ? '16px' : '15px',
        padding: window.innerWidth <= 768 ? '24px' : '40px',
        maxWidth: '500px',
        width: window.innerWidth <= 768 ? '100%' : '90%',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: window.innerWidth <= 768 ? '24px' : '30px'
        }}>
          <h2 style={{
            color: '#333',
            fontSize: window.innerWidth <= 768 ? '20px' : '24px',
            margin: 0
          }}>
            Truck Check Options
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '28px',
              cursor: 'pointer',
              color: '#666',
              padding: '4px',
              minWidth: '44px',
              minHeight: '44px'
            }}
          >
            ×
          </button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <button
            className="btn btn-primary btn-full"
            onClick={onCheckIn}
            style={{
              padding: window.innerWidth <= 768 ? '16px' : '20px',
              fontSize: window.innerWidth <= 768 ? '16px' : '18px',
              background: '#0E3293',
              borderColor: '#0E3293',
              minHeight: '44px'
            }}
          >
            Check In - Start of Shift
          </button>

          <button
            className="btn btn-primary btn-full"
            onClick={onCheckOut}
            style={{
              padding: window.innerWidth <= 768 ? '16px' : '20px',
              fontSize: window.innerWidth <= 768 ? '16px' : '18px',
              background: '#000',
              borderColor: '#000',
              minHeight: '44px'
            }}
          >
            Check Out - End of Shift
          </button>
        </div>

        <p style={{
          marginTop: '20px',
          fontSize: '14px',
          color: '#666',
          textAlign: 'center',
          lineHeight: '1.5'
        }}>
          Select Check In for the daily rig check at start of shift, or Check Out for end of shift debrief.
        </p>
      </div>
    </div>
  );
}

export default TruckCheckModal;
